import { render, staticRenderFns } from "./sm-border.vue?vue&type=template&id=28ae793f&"
import script from "./sm-border.vue?vue&type=script&lang=js&"
export * from "./sm-border.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28ae793f')) {
      api.createRecord('28ae793f', component.options)
    } else {
      api.reload('28ae793f', component.options)
    }
    module.hot.accept("./sm-border.vue?vue&type=template&id=28ae793f&", function () {
      api.rerender('28ae793f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/government/sm-union/components/sm-border.vue"
export default component.exports